module.exports = __webpack_public_path__ + "static/media/takeout.21dee307.pdf";